import { ref, onMounted } from 'vue';
import { musicService } from '~/services/musicService';

/** Display the backend's current configured charge, never a guessed fixed cost. */
export function useCreationPricing() {
  const creationPricing = ref<{ music?: Record<string, number>; album_cover?: number; lyrics?: number } | null>(null);
  const loading = ref(false);
  const refresh = async () => {
    loading.value = true;
    try {
      const response = await musicService.getSubscriptionConfig();
      if (response.code !== 200) throw new Error('Pricing unavailable');
      creationPricing.value = response.data?.creation_pricing || null;
    } catch { creationPricing.value = null; }
    finally { loading.value = false; }
  };
  onMounted(refresh);
  return { creationPricing, loading, refresh };
}
